export default __webpack_public_path__ + "static/media/RayanBenaissa.32ad3a4c.png";